import {
    Box,
    Typography,
} from '@mui/material'
import Icon1 from '../../../assets/personal-loan/why-choose1.png'
import Icon2 from '../../../assets/personal-loan/why-choose2.png'
import Icon3 from '../../../assets/personal-loan/why-choose3.png'
import Icon4 from '../../../assets/personal-loan/why-choose4.png'
import {Image} from 'antd'
import { useTranslation } from 'react-i18next'
import { isTablet } from 'react-device-detect'

export const SMWhyChoose: React.FC = () => {

    const { t } = useTranslation()

    const data = [
        {
            'icon': Icon1,
            'title': t('t213'),
            'content': t('t214'),
        },
        {
            'icon': Icon2,
            'title': t('t215'),
            'content': t('t216'),
        },
        {
            'icon': Icon3,
            'title': t('t217'),
            'content': t('t218'),
        },
        {
            'icon': Icon4,
            'title': t('t219'),
            'content': t('t220'),
        },
    ]

    const renderItem = (index: number) => {
        return (
            <Box key={index} sx={{
                flex: '1',
                paddingLeft: '15px',
                paddingRight: '15px'
            }}>
                <Box sx={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    borderRadius: '10px',
                    paddingLeft: isTablet ? '20px' : '40px',
                    paddingRight: isTablet ? '20px' : '40px',    
                    paddingTop: '40px',
                    paddingBottom: '40px',
                    alignItems: 'center',
                    boxShadow: '0px 10px 80px 3px #0000001A',
                }}>
                    <Image src={data[index]['icon']} width={80} height={80} alt='' preview={false}></Image>
                    <Typography fontSize={20} fontWeight={700} color={'#141F39'} paddingTop={'16px'} textAlign={'center'}>
                        {data[index]['title']}
                    </Typography>

                    <Typography fontSize={16} fontWeight={600} color={'#6B6B6B'} paddingTop={'16px'} textAlign={'center'}>
                        {data[index]['content']}
                    </Typography>
                </Box>
            </Box>
        )
    }

    // ======================= VIEWS
    return (
        <Box
            sx={{
                width: '100%',
                paddingLeft: '55px',
                paddingRight: '55px',
            }}
        >
            <Typography fontSize={32} fontWeight={700} color={'#141F39'} paddingTop={'60px'} textAlign={'center'}>
                {t('t212')}
            </Typography>

            <Box sx={{
                paddingTop: '40px',
                display: 'flex',
                flexDirection: 'row',
            }}>
                {data.map((item, index) => (
                    renderItem(index)
                ))}
            </Box>

        </Box >
    )
}

// ======================= EXPORT
export default SMWhyChoose
